import { VerificationModule } from './../verification/verification.module';
import { SharedModule } from 'src/app/shared/modules/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateAccountComponent } from './create-account/create-account.component';



@NgModule({
  declarations: [
    CreateAccountComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    VerificationModule
  ],
  exports: [
    CreateAccountComponent
  ]
})
export class AccountModule { }
